import Service, { service } from '@ember/service';

import { dropTask } from 'ember-concurrency';
import { queryManager } from 'ember-apollo-client';
import createPettyCashTransaction from 'my-phorest/gql/mutations/create-petty-cash-transaction.graphql';
import { htmlSafe } from '@ember/template';

const ERROR_VALIDATION_CODE_AFTER_CASH_UP_SALE = 'AFTER_CASH_UP_SALE';

export default class PettyCashTransactionsService extends Service {
  @queryManager apollo;
  @service confirmDialog;
  @service intl;
  @service session;
  @service electronApp;
  @service tillLoader;
  @service tillSessions;

  @dropTask
  *genericCreatePettyCashTransactionTask(
    variables,
    options = { openCashDrawer: false, forceDeleteCashUp: false }
  ) {
    const tillId = yield this.tillLoader.getCurrentTillIdTask.perform();
    yield this.tillSessions.prepareTillSession(tillId);
    let { pettyCashTransaction } = yield this.apollo.mutate(
      {
        mutation: createPettyCashTransaction,
        variables: {
          input: {
            ...variables,
            tillId,
          },
          forceDeleteCashUp: options.forceDeleteCashUp,
        },
      },
      'createPettyCashTransaction'
    );

    if (this.electronApp.isRunningInElectron && options.openCashDrawer) {
      this.electronApp.openCashDrawer();
    }

    if (this.session.isDACHLocale) {
      return this.confirmDialog.ask({
        hideCancelButton: true,
        title: this.intl.t('sales.petty-cash.create.transaction-no'),
        message: `A${pettyCashTransaction.transactionNo}`,
        continue: this.intl.t('global.ok'),
        leadingIcon: 'information-circle',
      });
    }
  }

  @dropTask
  *createPettyCashTransactionTask(variables, options) {
    try {
      yield this.genericCreatePettyCashTransactionTask.perform(
        variables,
        options
      );
    } catch (e) {
      if (
        e.errors?.[0]?.extensions?.validationCode ===
        ERROR_VALIDATION_CODE_AFTER_CASH_UP_SALE
      ) {
        const confirmed = yield this.confirmDialog.ask({
          title: this.intl.t(
            'sales.till-transactions.transaction-details.void-reopen-till-dialog.title'
          ),
          message: htmlSafe(
            this.intl.t(
              'sales.till-transactions.transaction-details.void-reopen-till-dialog.message'
            )
          ),
          continue: this.intl.t('global.continue'),
          cancel: this.intl.t('global.cancel'),
          leadingIcon: 'question-mark-circle',
        });

        if (confirmed) {
          return yield this.genericCreatePettyCashTransactionTask.perform(
            variables,
            { ...options, forceDeleteCashUp: true }
          );
        } else {
          return false;
        }
      }
      throw e;
    }
  }
}
